//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
/** Services Import */
import Global from '../../../../Services/Common/Global';
import Commons from '../../../../Services/Common/Common';
/** Components Import */
import M_TBG_CUSTOM_01 from './M_TBG_CUSTOM_01';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import {
  useSearch1,
  useSave1,
  useSave2,
  useDelete1,
} from './M_TBG_CUSTOM_01_Query';
import { useSave } from '../../../../Hooks/useSave';
import { useDelete } from '../../../../Hooks/useDelete';
//#endregion

function M_TBG_CUSTOM_01F(props) {
  //#region 변수
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [inputs, setInputs] = useState({
    video: '',
    isNext: false,
  });
  const videoRef = useRef();
  const [played, setPlayed] = useState(0);
  const [play, setPlay] = useState(false);
  const [eduStart, setEduStart] = useState(false);
  const [modalToggle1, setModalToggle1] = useState(true); // qr코드 모달
  const [qrcode, setQrcode] = useState();
  //#endregion

  useEffect(() => {
    return () => {
      dispatch(BottomSheetActions.CloseBottomSheet());
    };
  }, [dispatch]);

  //#region 쿼리
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      const videoLocation = rows[0]?.videoLocation;
      const tbmCd = rows[0]?.tbmCd;

      if (!videoLocation) {
        setInputs({
          ...inputs,
          video: '',
          isNext: true,
        });
      } else {
        const videoFullUrl = GetFullFileUrl(videoLocation);
        setInputs((prev) => ({
          ...prev,
          video: videoFullUrl,
        }));
      }
      setQrcode(tbmCd);
    },
  });
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { runAsync: Delete1Async } = useDelete1();

  // 저장
  const { run: Save1 } = useSave({
    menuId: 'M_TBG_CUSTOM_01',
    requestSave: (rows) => Save1Async(rows),
    onSuccess: (rows) => {
      if (rows.saveDetailData[0]?.data[0]?.TbmStartDate) {
        props.startTimeRef.current = new Date(
          rows.saveDetailData[0]?.data[0]?.TbmStartDate
        );
      }
    },
  });
  const { run: Save2 } = useSave({
    menuId: 'M_TBG_CUSTOM_01',
    requestSave: (rows) => Save2Async(rows),
  });

  // 삭제
  const { run: Delete1 } = useDelete({
    menuId: 'M_TBG_CUSTOM_01',
    requestDelete: (rows) => Delete1Async({ tbmCd: props.tbmCdRef.current }),
  });
  //#endregion

  //#region 나머지 함수
  const GetFullFileUrl = (relativePath) => {
    if (!relativePath) return '';
    const fixedPath = Commons.EncodeUrl(relativePath);
    return `${Global.file.useUrl}files/${fixedPath}`;
  };

  const HandleVideoError = (e) => {
    console.log('Video Error: ', e);
    if (e.type === 'error') {
      setInputs({
        ...inputs,
        video: '',
        isNext: true,
      });
    }
  };

  const HandleVideoEnd = () => {
    setInputs({
      ...inputs,
      isNext: true,
    });
  };

  const HandleProgress = (state) => {
    setPlayed(state.played);
  };

  const HandleSeek = () => {
    if (!videoRef.current) return;
    try {
      const currentTime = videoRef.current.getCurrentTime();
      const duration = videoRef.current.getDuration();
      if (!duration || duration === 0) return;
      const playedFraction = currentTime / duration;
      if (playedFraction > played) {
        setPlayed(playedFraction);
      }
    } catch (error) {
      console.log('Seek Error: ', error);
    }
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TBG_CUSTOM_01
        userInfo={userInfo}
        lanList={lanInfo}
        inputs={inputs}
        setInputs={setInputs}
        videoRef={videoRef}
        play={play}
        setPlay={setPlay}
        eduStart={eduStart}
        setEduStart={setEduStart}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        qrcode={qrcode}
        setQrcode={setQrcode}
        activeStep={activeStep}
        setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
        userCount={props.userCount}
        setUserCount={props.setUserCount}
        tbmCdRef={props.tbmCdRef}
        ActiveButton={props.ActiveButton}
        SaveLogic1={Save1}
        SaveLogic2={Save2}
        HandleVideoError={HandleVideoError}
        HandleVideoEnd={HandleVideoEnd}
        HandleProgress={HandleProgress}
        HandleSeek={HandleSeek}
        DeleteLogic1={Delete1}
      />
    </div>
  );
}

export default M_TBG_CUSTOM_01F;
